import Vuex from "vuex";
import Vue from "vue";
import themeConfig from "./modules/themeConfig";

import state from "./states.js";
import getters from "./getters.js";
import mutations from "./mutations.js";
import actions from "./actions.js";

import mCommon from "./modules/CommonInfo.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    mCommon,
    themeConfig,
  },
  state,
  getters,
  mutations,
  actions,
});
